module.exports = __webpack_public_path__ + "static/media/ceilings_gwp_60yd_y.332859fb.csv";